<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title">{{$t('medium_grant.diligence__5_financial')}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <label><strong>{{$t('medium_grant.diligence__5_financial_audit')}}</strong></label>
        <div>
          <small>{{$t('medium_grant.diligence__5_financial_audit_sub')}}</small>
        </div>
        <div class="mt-3"></div>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.doesOrgHaveAudit"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.doesOrgHaveAudit"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.doesOrgHaveAudit" value="false" v-model="GrantForm.revisionModel.diligence.doesOrgHaveAudit">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <label class="mt-3">{{$t('medium_grant.diligence__5_if_yes_provide_audit_copy')}}</label>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.auditExplainWhy"
            >
            </textarea>
        </base-input>
      </div>
      <div class="col-lg-4">
        <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionAuditorAnnualReport" :file-data="GrantForm.files.diligence.revisionAuditorAnnualReport" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.revisionAuditorAnnualReport"></upload-file>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <label class="mt-3">{{$t('medium_grant.diligence__5_if_do_not_have_independent_audit')}}</label>
        <div>
          <small>{{$t('medium_grant.diligence__5_if_do_not_have_independent_audit_sub')}}</small>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="mt-3"></div>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.doesOrgPrepareAnualFinancial"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.doesOrgPrepareAnualFinancial"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.doesOrgPrepareAnualFinancial" value="false" v-model="GrantForm.revisionModel.diligence.doesOrgPrepareAnualFinancial">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
        </div>
        <label class="mt-3">{{$t('medium_grant.diligence__5_if_do_not_have_independent_audit_sub_explaination')}}</label>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.doesOrgPrepareAnualFinancialWhy"
            >
            </textarea>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div>
          <label class="mt-3">{{$t('medium_grant.diligence__5_provide_copy_org_financial_covering')}}</label>
        </div>
        <div>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionAuditAnualStatement" :file-data="GrantForm.files.diligence.revisionAuditAnualStatement" :size-limit="GrantForm.fileSizeLimit" :is-editable="GrantForm.isRevisionEditable" section="diligence.revisionAuditAnualStatement"></upload-file>
        </div>
        <div>
          <label class="mt-3"><strong>{{$t('medium_grant.diligence__5_financial_principles')}}</strong></label>
        </div>
        <div>
          <label class="mt-3">{{$t('medium_grant.diligence__5_what_computerized_accounting')}}</label>
        </div>
      </div>
      <div class="col-lg-4">
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.whatComputerizedAccounting"
            >
            </textarea>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="mt-3"></div>
        <label class="mt-3">{{$t('medium_grant.diligence__5_does_org_accounting_separately')}}</label>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.doesOrgAccountingSeparately"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.doesOrgAccountingSeparately"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.doesOrgAccountingSeparately" value="false" v-model="GrantForm.revisionModel.diligence.doesOrgAccountingSeparately">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="mt-3"></div>
        <label class="mt-3">{{$t('medium_grant.diligence__5_does_org_written_policies')}}</label>
      </div>
      <div class="col-lg-12">
        <div>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="diligence.doesOrgPolicyAccounting"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.doesOrgPolicyAccounting"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.doesOrgPolicyAccounting" value="false" v-model="GrantForm.revisionModel.diligence.doesOrgPolicyAccounting">
              {{$t('medium_grant.general__no')}}
            </radio>
            <label>{{$t('medium_grant.diligence__5_policy_accounting')}}</label>
          </div>
        </div>
        <div>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="diligence.doesOrgPolicyProcurement"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.doesOrgPolicyProcurement"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.doesOrgPolicyProcurement" value="false" v-model="GrantForm.revisionModel.diligence.doesOrgPolicyProcurement">
              {{$t('medium_grant.general__no')}}
            </radio>
            <label>{{$t('medium_grant.diligence__5_policy_procurement')}}</label>
          </div>
        </div>
        <div>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="diligence.doesOrgPolicyCode"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.doesOrgPolicyCode"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.doesOrgPolicyCode" value="false" v-model="GrantForm.revisionModel.diligence.doesOrgPolicyCode">
              {{$t('medium_grant.general__no')}}
            </radio>
            <label>{{$t('medium_grant.diligence__5_policy_code')}}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div>
          <label class="mt-4"><strong>{{$t('medium_grant.diligence__5_debt')}}</strong></label>
        </div>
        <div>
          <small>{{$t('medium_grant.diligence__5_debt_sub')}}</small>
        </div>
        <div>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="diligence.debtBankLoan"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.debtBankLoan"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.debtBankLoan" value="false" v-model="GrantForm.revisionModel.diligence.debtBankLoan">
              {{$t('medium_grant.general__no')}}
            </radio>
            <label>{{$t('medium_grant.diligence__5_debt_bank_loan')}}</label>
          </div>
        </div>
        <div>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="diligence.debtBankOverdraft"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.debtBankOverdraft"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.debtBankOverdraft" value="false" v-model="GrantForm.revisionModel.diligence.debtBankOverdraft">
              {{$t('medium_grant.general__no')}}
            </radio>
            <label>{{$t('medium_grant.diligence__5_debt_bank_overdraft')}}</label>
          </div>
        </div>
        <div>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="diligence.debtOther"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.debtOther"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.debtOther" value="false" v-model="GrantForm.revisionModel.diligence.debtOther">
              {{$t('medium_grant.general__no')}}
            </radio>
            <label>{{$t('medium_grant.diligence__5_debt_other')}}</label>
          </div>
        </div>
        <div>
          <div class="mt-4">
            <label>{{$t('medium_grant.diligence__5_debt_other_if_yes')}}</label>
          </div>
          <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.debtOtherText"
            >
            </textarea>
          </base-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div>
          <label class="mt-3"><strong>{{$t('medium_grant.diligence__5_insurance')}}</strong></label>
        </div>
        <div>
          <label>{{$t('medium_grant.diligence__5_insurance_tick_policies')}}</label>
        </div>
        <table width="50%">
          <tr>
            <td width="40%">{{$t('medium_grant.diligence__5_insurance_third_party')}}</td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.insuranceThirdParty"
            :placeholder="$t('medium_grant.diligence__5_insurance_amount')"
            v-model="GrantForm.revisionModel.diligence.insuranceThirdParty"
          >
          </textarea>
              </div>
            </td>
          </tr>
          <tr>
            <td width="20%">{{$t('medium_grant.diligence__5_insurance_office_building')}}</td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.insuranceOfficeBuilding"
            :placeholder="$t('medium_grant.diligence__5_insurance_amount')"
            v-model="GrantForm.revisionModel.diligence.insuranceOfficeBuilding"
          >
          </textarea>
              </div>
            </td>
          </tr>
          <tr>
            <td width="20%">{{$t('medium_grant.diligence__5_insurance_vehicles')}}</td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.insuranceVehicles"
            :placeholder="$t('medium_grant.diligence__5_insurance_amount')"
            v-model="GrantForm.revisionModel.diligence.insuranceVehicles"
          >
          </textarea>
              </div>
            </td>
          </tr>
          <tr>
            <td width="20%">{{$t('medium_grant.diligence__5_insurance_others')}}</td>
            <td>
              <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.insuranceTypes"
            >
            </textarea>
              </base-input>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="mt-3"></div>
        <label class="mt-3"><strong>{{$t('medium_grant.diligence__5_bank_accounts_and_funds_control')}}</strong></label>
        <div>
          <label>{{$t('medium_grant.diligence__5_bank_accounts_and_funds_control_sub')}}</label>
        </div>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.doesOrgHaveBankAccountsHeld"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.doesOrgHaveBankAccountsHeld"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.doesOrgHaveBankAccountsHeld" value="false" v-model="GrantForm.revisionModel.diligence.doesOrgHaveBankAccountsHeld">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
        </div>
        <div>
          <label>{{$t('medium_grant.diligence__5_bank_if_yes')}}</label>
        </div>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.orgBankAccountsHeldText"
            >
            </textarea>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="mt-3"></div>
        <div>
          <label>{{$t('medium_grant.diligence__5_bank_at_least_two_signatures')}}</label>
        </div>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.areTwoBankSignatories"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.areTwoBankSignatories"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.areTwoBankSignatories" value="false" v-model="GrantForm.revisionModel.diligence.areTwoBankSignatories">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
        </div>
        <div>
          <label>{{$t('medium_grant.diligence__5_bank_at_least_two_signatures_sub')}}</label>
        </div>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.areTwoBankSignatoriesText"
            >
            </textarea>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="mt-3"></div>
        <div>
          <label>{{$t('medium_grant.diligence__5_will_funds_kept_outside')}}</label>
        </div>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.willFundsBeKeptOutside"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.willFundsBeKeptOutside"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.willFundsBeKeptOutside" value="false" v-model="GrantForm.revisionModel.diligence.willFundsBeKeptOutside">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
        </div>
        <div>
          <label>{{$t('medium_grant.diligence__5_will_funds_kept_outside_sub')}}</label>
        </div>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.willFundsBeKeptOutsideText"
            >
            </textarea>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-3"></div>
        <label class="mt-3"><strong>{{$t('medium_grant.diligence__5_financial_capacity')}}</strong></label>
        <div>
          <label>{{$t('medium_grant.diligence__5_financial_capacity_sub')}}</label>
        </div>
        <table width="100%">
          <tr>
            <td width="20%">{{$t('medium_grant.diligence__5_financial_capacity_this_year')}}</td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.financialCapacityThisYearLeft"
            v-model="GrantForm.revisionModel.diligence.financialCapacityThisYearLeft"
          >
          </textarea>
              </div>
            </td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.financialCapacityThisYearRight"
            v-model="GrantForm.revisionModel.diligence.financialCapacityThisYearRight"
          >
          </textarea>
              </div>
            </td>
          </tr>
          <tr>
            <td width="20%">{{$t('medium_grant.diligence__5_financial_capacity_last_year')}}</td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.financialCapacityLastYearLeft"
            v-model="GrantForm.revisionModel.diligence.financialCapacityLastYearLeft"
          >
          </textarea>
              </div>
            </td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.financialCapacityLastYearRight"
            v-model="GrantForm.revisionModel.diligence.financialCapacityLastYearRight"
          >
          </textarea>
              </div>
            </td>
          </tr>
          <tr>
            <td width="20%">{{$t('medium_grant.diligence__5_financial_capacity_two_years_ago')}}</td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.financialCapacityTwoYearsAgoLeft"
            v-model="GrantForm.revisionModel.diligence.financialCapacityTwoYearsAgoLeft"
          >
          </textarea>
              </div>
            </td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            name="diligence.financialCapacityTwoYearsAgoRight"
            v-model="GrantForm.revisionModel.diligence.financialCapacityTwoYearsAgoRight"
          >
          </textarea>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="mt-4">
          <label>{{$t('medium_grant.diligence__5_financial_org_received_funds_from_gov')}}</label>
        </div>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.orgReceivedFundsFromGov"
                   value="true"
                   v-model="GrantForm.revisionModel.diligence.orgReceivedFundsFromGov"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="diligence.orgReceivedFundsFromGov" value="false" v-model="GrantForm.revisionModel.diligence.orgReceivedFundsFromGov">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="mt-4">
          <label>{{$t('medium_grant.diligence__5_financial_what_percentage_grant')}}</label>
        </div>
        <div>
          <div class="form-check form-check-radio">
            <radio name="diligence.percentageGotFromGrant" value="0-50" v-model="GrantForm.revisionModel.diligence.percentageGotFromGrant">
              {{$t('medium_grant.diligence__5_percentange_0_50')}}
            </radio>
            <radio name="diligence.percentageGotFromGrant" value="76-95" v-model="GrantForm.revisionModel.diligence.percentageGotFromGrant">
              {{$t('medium_grant.diligence__5_percentange_76_95')}}
            </radio>
            <radio name="diligence.percentageGotFromGrant" value="51-75" v-model="GrantForm.revisionModel.diligence.percentageGotFromGrant">
              {{$t('medium_grant.diligence__5_percentange_51_75')}}
            </radio>
            <radio name="diligence.percentageGotFromGrant" value="95" v-model="GrantForm.revisionModel.diligence.percentageGotFromGrant">
              {{$t('medium_grant.diligence__5_percentange_95')}}
            </radio>
          </div>
        </div>
        <div class="mt-4">
          <label>{{$t('medium_grant.diligence__5_financial_list_main_donors')}}</label>
        </div>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.mainDonors"
            >
            </textarea>
        </base-input>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
